import { API_ENDPOINT } from '../config';

export const PERFORMANCE_ACTIVE_STATUS = 'active'
export const PERFORMANCE_PASSED_STATUS = 'passed'
export const PERFORMANCE_DISABLED_STATUS = 'disabled'

export default function(id) {
    return fetch(`${API_ENDPOINT}/performances/${id}/`);
}
